import React, { ReactNode } from "react";
import { FloatingNavCapsule } from "./FloatingNavCapsule";

interface ShellProps {
  theme: "dark" | "light";
  onToggleTheme: () => void;
  children: ReactNode;
}

export const Shell: React.FC<ShellProps> = ({ theme, onToggleTheme, children }) => {
  return (
    <div className="min-h-screen bg-[#141413] text-[#F3F2EE] font-sans selection:bg-[#3E3C37] selection:text-white relative transition-colors duration-200">
      {/* Accessible Skip Link */}
      <a href="#hero" className="skip-link">
        Skip to main content
      </a>

      {/* Floating Capsule Navigation with Vintage Switch */}
      <FloatingNavCapsule theme={theme} onToggleTheme={onToggleTheme} />

      {/* Main Page Content */}
      <main id="main-content" className="w-full">
        {children}
      </main>
    </div>
  );
};
